import { useEffect, useState } from "react";
import { defaultProfileImage } from "../../../utils/constants"
import { getIntroductionDetailById } from "../../../services/introductionService";
import { IntroductionDetail } from "../models";
import { handleImageErrorProfile } from "../../../utils/UtilsFiles";
import { DeclineModal } from "../../introductions/componentes/modals/DeclineModal";
import { AcceptModal } from "../../introductions/componentes/modals/AcceptModal";
import { IntroductionRequest } from "../../introductions/models";

type Props = {
    id:number
    onClose: () => void;
    onComplete: () => void;
}

export const IntroductionAdminDetails = ({ id, onClose, onComplete }: Props) => {
    const [detail,setDetail] = useState<IntroductionRequest>()
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showAcceptModal, setShowAcceptModal] = useState(false);

    useEffect(()=>{
        if(id>0) getDetail(id)
    },[id])

    const getDetail = async (id:number) => {
        const introduction_ = await getIntroductionDetailById(id)
        setDetail(introduction_)
    }

    const handleReject = async () => {
        setShowDeclineModal(true)
    }

    const handleAccept = async () => {
        setShowAcceptModal(true)
    }

    return (
        <div className="introduction-admin-details-wrapper">

            <div className="introduction-admin-details">
                <div className="d-flex flex-row w-100 align-items-center justify-content-between">
                    <h3>Introduction Detail</h3>
                    <button onClick={onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M16.0003 29.3337C23.3337 29.3337 29.3337 23.3337 29.3337 16.0003C29.3337 8.66699 23.3337 2.66699 16.0003 2.66699C8.66699 2.66699 2.66699 8.66699 2.66699 16.0003C2.66699 23.3337 8.66699 29.3337 16.0003 29.3337Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.2266 19.7732L19.7733 12.2266" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.7733 19.7732L12.2266 12.2266" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>

                <div className="details">
                    <div className="d-flex flex-row align-items-center" style={{ gap: '10px' }}>
                        <span className="text-muted">Assigned Admin</span>
                        <img src={detail?.assignedAdmin?.avatar ?? ''} onError={handleImageErrorProfile}/>
                        <span className="text-body">{detail?.assignedAdmin?.username ?? 'N/A'}</span>
                    </div>


                    <div className="d-flex flex-row w-100 justify-content-between align-items-center">
                        <div className="d-flex flex-column">
                            <span className="text-italic">#{detail?.id}</span>
                            <span className="text-bold">{detail?.type}</span>
                        </div>
                        <span className="text-body" style={{ fontWeight: '300' }}>{detail?.status}</span>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="508" height="1" viewBox="0 0 508 1" fill="none">
                        <path d="M0 0.5H508" stroke="#E9E9E9"/>
                    </svg>

                    <div className="d-flex flex-column w-100" style={{ gap: '5px' }}>
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className="d-flex flex-column">
                                <span className="text-subtitle">Requester</span>
                                <div className="author-wrapper">
                                    <img src={detail?.requester?.avatar} onError={handleImageErrorProfile}/>
                                    <span className="author-name">{detail?.requester?.username}</span>
                                    <span className="tier">{detail?.requester?.tier ?? 'N/A'}</span>
                                </div>
                            </div>


                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M16.0003 29.3337C23.3641 29.3337 29.3337 23.3641 29.3337 16.0003C29.3337 8.63653 23.3641 2.66699 16.0003 2.66699C8.63653 2.66699 2.66699 8.63653 2.66699 16.0003C2.66699 23.3641 8.63653 29.3337 16.0003 29.3337Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.333 16H19.333" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.667 20L20.667 16L16.667 12" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>


                            <div className="d-flex flex-column">
                                <span className="text-subtitle">Recipient</span>
                                <div className="author-wrapper">
                                    <img src={detail?.recipent?.avatar} onError={handleImageErrorProfile}/>
                                    <span className="author-name">{detail?.recipent?.username}</span>
                                    <span className="tier">{detail?.recipent?.tier ?? 'N/A'}</span>
                                </div>
                            </div>

                            
                        </div>
                        <span className="text-body" style={{ fontWeight: '300' }}>{detail?.requesterStatus}</span>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="508" height="1" viewBox="0 0 508 1" fill="none">
                        <path d="M0 0.5H508" stroke="#E9E9E9"/>
                    </svg>

                    <div className="d-flex flex-column" style={{ gap: '20px' }}>
                        <div className="author-wrapper">
                            <img src={detail?.requester?.avatar} onError={handleImageErrorProfile} />
                            <span className="author-name">{detail?.requester?.username}</span>
                        </div>

                        <div className="d-flex flex-column" style={{ gap: '10px' }}>
                            <span className="text-subtitle">TOPIC</span>
                            <span className="text-bold">{detail?.topic}</span>
                        </div>

                        <div className="d-flex flex-column" style={{ gap: '10px' }}>
                            <span className="text-subtitle">MESSAGE</span>
                            <p className="text-body" style={{ fontWeight: '300' }}>
                                {detail?.message}
                            </p>
                        </div>
                    </div>


                </div>

                {detail?.status == 'PENDING' && (<div className="d-flex flex-row align-items-center justify-content-between w-100">
                    <button className="btn-secundary" onClick={handleReject}>
                        Decline introduction
                    </button>

                    <button className="btn-action-primary" onClick={handleAccept}>
                        Approve introduction
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                            <path d="M8.5 0.379883L12 3.38403H0" stroke="white"/>
                        </svg>
                    </button>
                </div>)}

            </div>

            <div className="backdrop" onClick={onClose}></div>
            {showDeclineModal && (<DeclineModal introduction={detail} open={showDeclineModal} onCancel={()=>setShowDeclineModal(false)} onComplete={onComplete} />)}
            {showAcceptModal && (<AcceptModal introduction={detail} open={showAcceptModal} onCancel={()=>setShowAcceptModal(false)} onComplete={onComplete} />)}
        </div>
    )
}